export enum ProjectTypeEnum {
    App,
    Website,
    Game,
    CrossPlatform,
    Unity
}